/**
 * Lightweight stale-while-revalidate cache for student journey reads.
 *
 * Stores GET responses in localStorage so a returning student sees the
 * map instantly (cache-first), then revalidates in the background. If the
 * server is momentarily down, the cached payload keeps the UI alive
 * instead of dropping the student to an error screen.
 *
 * Keys are namespaced by user when possible, otherwise per route.
 */

const NS = 'pkc:journey-cache:';
const DEFAULT_TTL_MS = 60_000; // 60 seconds — fresh enough, gentle on backend

export function readCache(key) {
  try {
    const raw = localStorage.getItem(NS + key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    return parsed; // { data, savedAt }
  } catch (_e) {
    return null;
  }
}

export function writeCache(key, data) {
  try {
    localStorage.setItem(NS + key, JSON.stringify({ data, savedAt: Date.now() }));
  } catch (_e) { /* quota errors are silent */ }
}

export function clearCache(key) {
  try { localStorage.removeItem(NS + key); } catch (_e) { /* ignore */ }
}

export function isFresh(entry, ttlMs = DEFAULT_TTL_MS) {
  if (!entry?.savedAt) return false;
  return (Date.now() - entry.savedAt) < ttlMs;
}

export default { readCache, writeCache, clearCache, isFresh };
